import { render, staticRenderFns } from "./MemberEditRolePage.vue?vue&type=template&id=24b8e50a&scoped=true"
import script from "./MemberEditRolePage.vue?vue&type=script&lang=js"
export * from "./MemberEditRolePage.vue?vue&type=script&lang=js"
import style0 from "./MemberEditRolePage.vue?vue&type=style&index=0&id=24b8e50a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b8e50a",
  null
  
)

export default component.exports